<template>
  <section class="ftco-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 text-center mb-5 boxLogoAuthWrapper" v-if="!config.isWhiteLabel">
          <div>
            <img src="/admin/assets/images/logo-v2-chat-inteligente-fundo-branco.png" style="max-height: 50px" />
          </div>
        </div>
        <div class="col-md-6 text-center mb-5 boxLogoAuthWrapper" 
            v-else-if="reseller?.logoUrlExterno || reseller?.logoUrl">
          <img :src="reseller?.logoUrlExterno ? reseller.logoUrlExterno : reseller?.logoUrl" 
              style="max-height: 50px" alt="Logo" />
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-5">
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import {loadScriptContent} from "../../../public/js/insere-script";
import {carregaAnalyticsCi} from "../../../public/js/insere-script";

export default {
  name: "AuthWrapper",
  computed: {
    ...mapGetters(["config"]),
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reseller: null, // Para armazenar o reseller
      flg_carregou_script_revenda: false
    };
  },
  watch: {
    reseller(newValue) {
      if (newValue) {
        const scriptContent = this.reseller?.desc_scripts_revendedor;
        const scriptLoaded = loadScriptContent(scriptContent, this.flg_carregou_script_revenda);
        if (scriptLoaded) {
          this.flg_carregou_script_revenda = true;
          console.log('carregou script');
        }
      }
    },
  },
  mounted() {
    console.log('this.config', this.config);
    if (this.config.isWhiteLabel) {
      this.fetchResellerLogo();
    } else {
      this.updateTitleAndFavicon(null); // Configuração padrão
      //Carrega o analytics do CI
      carregaAnalyticsCi();
    }
  },
  methods: {
    async fetchResellerLogo() {
      try {
        const domain = window.location.hostname; // Obtém o domínio atual
        const response = await axios.post(`/api/getResellerByDomain`, {domain});

        if (response.data.success && response.data.reseller) {
          this.reseller = response.data.reseller;
          console.log('reseler',this.reseller);
          this.updateTitleAndFavicon(this.reseller); // Configurar com dados do reseller
        }
      } catch (error) {
        console.error("Erro ao buscar dados do reseller:", error);
        this.updateTitleAndFavicon(null); // Configuração padrão em caso de erro
      }
    },
    updateTitleAndFavicon(reseller) {
      const head = document.head;

      // Atualizar o <title>
      if (reseller) {
        document.title = reseller.slug || reseller.description || "Reseller Dashboard";
      } else {
        document.title = "Chat Inteligente!";
      }

      // Configurar favicon
      const setFavicon = (href, rel = "icon", type = null, sizes = null) => {
        let existingLink = head.querySelector(`link[rel="${rel}"]`);
        if (!existingLink) {
          existingLink = document.createElement("link");
          existingLink.rel = rel;
          if (type) existingLink.type = type;
          if (sizes) existingLink.sizes = sizes;
          head.appendChild(existingLink);
        }
        existingLink.href = href;
      };

      if (reseller && reseller.logoFavicon) {
        const faviconUrl = reseller.logoFavicon;
        setFavicon(faviconUrl, "icon", "image/png");
        setFavicon(faviconUrl, "apple-touch-icon", null, "180x180");
      } else {
        setFavicon("/admin/assets/images/favicon/apple-touch-icon.png", "apple-touch-icon", null, "180x180");
        setFavicon("/admin/assets/images/favicon/favicon-32x32.png", "icon", "image/png", "32x32");
        setFavicon("/admin/assets/images/favicon/favicon-16x16.png", "icon", "image/png", "16x16");
      }
    },
  },
};
</script>

<style>
@import "@/views/assets/css/login_style.css";
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css");
</style>
